import React from 'react';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';

const Header = ({ title }: { title: string }) => {
    const navigate = useNavigate();
    const [cookies, setCookie, removeCookie] = useCookies(['user-data', "token"]);
    const handleLogout = () => {
        removeCookie("user-data");
        removeCookie("token");
        navigate("/");
    };

    return (
        <header className='bg-gray-200 bg-opacity-50 backdrop-blur-md shadow-lg border-b border-gray-500'>
            <div className='max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8 flex justify-between items-center'>
                {/* Title centered */}
                <h2 className='text-2xl font-semibold text-gray-900 text-center flex-1'>{title}</h2>

                <button
                    onClick={handleLogout}
                    className='bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600 transition duration-200'
                >
                    تسجيل الخروج
                </button>
            </div>
        </header>
    );
};

export default Header;